import {
  ConnectSubscriptionFormValues,
  ContactUsFormValues,
  LoginFormValues,
  PasswordResetFormValues,
  PositionAssignmentFormValues,
  PreRegisterFormValues,
} from 'utilities/resources/formItemValues'
import { FormItems, ValidateResult } from 'utilities/validators'

/**
 * ログインの項目リスト
 */
export const loginFormItems: FormItems<LoginFormValues> = {
  email: {
    label: 'メールアドレス',
    name: 'email',
    type: 'must',
  },
  password: {
    label: 'パスワード',
    name: 'password',
    type: 'must',
  },
}

/**
 * お申込み・承諾の項目リスト
 */
export const connectSubscriptionFormItems: FormItems<ConnectSubscriptionFormValues> = {
  countryNumber: {
    label: '国際番号+',
    name: 'country-number',
    type: 'must',
  },
  phoneNumber: {
    label: '携帯電話番号',
    name: 'phone-number',
    type: 'must',
  },
  businessForm: {
    label: 'ご契約名義',
    name: 'user-type',
    type: 'must',
  },
  companyName: {
    label: '法人名',
    name: 'company-name',
    type: 'company',
  },
  companyNameKana: {
    label: '法人名（カナ）',
    name: 'company-name-kana',
    type: 'company',
  },
  companyInvoiceNumber: {
    label: '適格事業者番号（インボイス番号）',
    name: 'company-invoice-number',
    type: 'none',
    checks: [ValidateResult.Invalid],
  },
  lastName: {
    label: '姓',
    name: 'last-name',
    type: 'must',
  },
  firstName: {
    label: '名',
    name: 'first-name',
    type: 'must',
  },
  lastNameKana: {
    label: '姓（カナ）',
    name: 'last-name-kana',
    type: 'must',
  },
  firstNameKana: {
    label: '名（カナ）',
    name: 'first-name-kana',
    type: 'must',
  },
  lastNameAlphabet: {
    label: '姓（ローマ字）',
    name: 'last-name-alphabet',
    type: 'subscription',
  },
  firstNameAlphabet: {
    label: '名（ローマ字）',
    name: 'first-name-alphabet',
    type: 'subscription',
  },
  gender: {
    label: '性別',
    name: 'gender',
    type: 'must',
  },
  email: {
    label: 'メールアドレス',
    name: 'email',
    type: 'none',
  },
  birthday: {
    label: '生年月日(西暦)',
    name: 'birthday',
    type: 'none',
  },
  bankCode: {
    label: '金融機関コード',
    name: 'bank-code',
    type: 'must',
  },
  bankName: {
    label: '金融機関名',
    name: 'bank-name',
    type: 'must',
  },
  bankType: {
    label: '口座種類',
    name: 'bank-type',
    type: 'must',
  },
  bankBranchCode: {
    label: '店番号',
    name: 'bank-branch-code',
    type: 'must',
  },
  bankBranchName: {
    label: '支店名',
    name: 'bank-branch-name',
    type: 'must',
  },
  bankAccountNumber: {
    label: '口座番号（7桁）',
    name: 'bank-account-number',
    type: 'must',
  },
  bankAccountName: {
    label: '口座名義人（全角カナ）',
    name: 'bank-account-name',
    type: 'none',
  },
  bankAccountLastName: {
    label: '口座名義人（全角カナ）',
    name: 'bank-account-last-name',
    type: 'none',
  },
  bankAccountFirstName: {
    label: '口座名義人（全角カナ）',
    name: 'bank-account-first-name',
    type: 'none',
  },
  bankAccountNameForConfirmation: {
    label: '口座名義人',
    name: 'bank-account-name',
    type: 'none',
  },
  postalCode: {
    label: '郵便番号',
    name: 'postal-code',
    type: 'must',
  },
  prefecture: {
    label: '都道府県',
    name: 'prefecture',
    type: 'must',
  },
  address: {
    label: '以降の住所',
    name: 'address',
    type: 'must',
  },
  receivePostalCode: {
    label: '郵便番号',
    name: 'receive-postal-code',
    type: 'none',
    checks: [ValidateResult.Invalid],
  },
  receivePrefecture: {
    label: '都道府県',
    name: 'receive-prefecture',
    type: 'none',
  },
  receiveAddress: {
    label: '以降の住所',
    name: 'receive-address',
    type: 'none',
  },
}

/**
 * コネクター仮登録の項目リスト
 */
export const preRegisterFormItems: FormItems<PreRegisterFormValues> = {
  email: {
    label: 'メールアドレス',
    name: 'email',
    type: 'must',
  },
  businessForm: {
    label: 'ご契約名義',
    name: 'user-type',
    type: 'must',
  },
  companyName: {
    label: '法人名',
    name: 'company-name',
    type: 'company',
  },
  lastName: {
    label: '姓',
    name: 'last-name',
    type: 'must',
  },
  firstName: {
    label: '名',
    name: 'first-name',
    type: 'must',
  },
  birthday: {
    label: '生年月日（西暦）',
    name: 'birthday',
    type: 'must',
  },
  password: {
    label: 'パスワード',
    name: 'password',
    type: 'must',
    errorMessages: {
      [ValidateResult.LengthTooShort]: '{item}は8文字以上にしてください。',
    },
  },
  passwordConfirm: {
    label: 'パスワード確認',
    name: 'password-confirm',
    type: 'must',
    errorMessages: {
      [ValidateResult.LengthTooShort]: '{item}は8文字以上にしてください。',
      [ValidateResult.Mismatch]: 'パスワードが一致していません。',
    },
  },
  summaryDocumentKind: {
    label: '',
    name: 'summary-document-kind',
    type: 'none',
  },
  summaryDocumentNumbers: {
    label: '',
    name: 'summary-document-numbers',
    type: 'none',
  },
}

/**
 * お問い合わせの項目リスト
 */
export const contactUsFormItems: FormItems<ContactUsFormValues> = {
  connectorId: {
    label: 'コネクターID',
    name: 'connector-id',
    type: 'none',
  },
  name: {
    label: '名前',
    name: 'name',
    type: 'must',
  },
  tel: {
    label: '電話番号',
    name: 'tel',
    type: 'must',
  },
  email: {
    label: 'メールアドレス',
    name: 'email',
    type: 'must',
  },
  category: {
    label: '相談カテゴリ',
    name: 'category',
    type: 'must',
  },
  body: {
    label: '相談内容',
    name: 'body',
    type: 'must',
  },
}

/**
 * 名義変更指定の項目リスト
 */
export const positionAssignmentFormItems: FormItems<PositionAssignmentFormValues> = {
  email: {
    label: 'メールアドレス',
    name: 'email',
    type: 'must',
  },
}

/**
 * パスワード再設定の項目リスト
 */
export const passwordResetFormItems: FormItems<PasswordResetFormValues> = {
  email: {
    label: 'メールアドレス',
    name: 'email',
    type: 'must',
  },
}
